console.log("Made with ❤️ by TONY RICHER");

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute("form", `${element.form.getAttribute("id")}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/**
 * Adds an observer to initialise a script when an element is scrolled into view.
 * @param {Element} element - Element to observe.
 * @param {Function} callback - Function to call when element is scrolled into view.
 * @param {number} [threshold=500] - Distance from viewport (in pixels) to trigger init.
 */
function initLazyScript(element, callback, threshold = 500) {
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof callback === "function") {
              callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: `0px 0px ${threshold}px 0px` }
    );

    io.observe(element);
  } else {
    callback();
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  };
}

customElements.define("header-drawer", HeaderDrawer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.initVariantRadios();
  }

  onVariantChange() {
    console.log("onVariantChange");
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    // Synchroniser les sélections avec les autres variant-radios
    this.syncVariantSelections();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();

      // Émettre un événement pour informer les autres composants
      const event = new CustomEvent("variant-changed", {
        detail: {
          variantId: this.currentVariant.id,
          variant: this.currentVariant,
        },
        bubbles: true,
      });
      this.dispatchEvent(event);
    }
  }

  connectedCallback() {
    // Écouter les changements de variant des autres composants
    document.addEventListener("variant-changed", (event) => {
      if (event.target !== this) {
        this.currentVariant = event.detail.variant;
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    });
  }

  syncVariantSelections() {
    // Pour chaque option sélectionnée
    const checkedInputs = this.querySelectorAll('input[type="radio"]:checked');
    checkedInputs.forEach((checkedInput) => {
      // Trouver tous les autres radio buttons avec le même nom et la même valeur sur la page
      const allMatchingInputs = document.querySelectorAll(`input[type="radio"][name="${checkedInput.name}"][value="${checkedInput.value}"]`);
      allMatchingInputs.forEach((input) => {
        if (input !== checkedInput) {
          input.checked = true;
        }
      });
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    console.log(this.currentVariant);
    console.log(this.dataset.updateUrl);
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    // Mettre à jour tous les inputs product-variant-id
    const inputsProductVariantId = document.querySelectorAll("input[name='id'].product-variant-id");
    inputsProductVariantId.forEach((input) => {
      if (this.currentVariant) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const disponibiliteSource = html.getElementById(`disponibilite-${this.dataset.section}`);
        const addButtonSource = html.getElementById(`Inventory-${this.dataset.section}`);
        const addButtonDestination = document.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const delaisDeLivraisonSource = html.getElementById(`delais-de-livraison-${this.dataset.section}`);
        const delaisDeLivraisonDestination = document.getElementById(`delais-de-livraison-${this.dataset.section}`);

        if (delaisDeLivraisonSource && delaisDeLivraisonSource.value !== "") {
          delaisDeLivraisonDestination.value = delaisDeLivraisonSource.value;
        } else if (delaisDeLivraisonDestination) {
          delaisDeLivraisonDestination.removeAttribute("value");
        }

        const deliveryTimesSource = html.getElementById(`delivery-times-${this.dataset.section}`);
        const deliveryTimesDestination = document.getElementById(`delivery-times-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        if (deliveryTimesSource && deliveryTimesDestination) deliveryTimesDestination.innerHTML = deliveryTimesSource.innerHTML;

        if (addButtonSource && addButtonDestination) addButtonDestination.innerHTML = addButtonSource.innerHTML;
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (disponibiliteSource && disponibiliteSource.value === "Réservation") {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.reservation);
        } else if (disponibiliteSource && disponibiliteSource.value === "Précommande") {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.precommande);
        } else if (disponibiliteSource) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else if (text == "Réservation" || text == "Précommande") {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  initVariantRadios() {
    // Récupérer le variant ID depuis l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (variantId) {
      // Trouver le variant correspondant dans les données
      const variant = this.getVariantData().find((v) => v.id === parseInt(variantId));

      if (variant) {
        // Mettre à jour this.currentVariant
        this.currentVariant = variant;

        // Pour chaque option du variant (option1, option2, option3)
        ["option1", "option2", "option3"].forEach((optionKey) => {
          const optionValue = variant[optionKey];
          if (optionValue) {
            // Trouver tous les radio buttons avec cette valeur
            const radios = this.querySelectorAll(`input[type="radio"][value="${optionValue}"]`);
            radios.forEach((radio) => {
              radio.checked = true;
            });
          }
        });

        // Mettre à jour l'input product-variant-id
        const inputsProductVariantId = document.querySelectorAll("input[name='id'].product-variant-id");
        if (inputsProductVariantId) {
          inputsProductVariantId.forEach((input) => {
            input.value = variant.id;
          });
        }
      }
    } else {
      // Si pas de variant dans l'URL, utiliser le variant sélectionné par défaut
      this.currentVariant = this.getVariantData().find((variant) => variant.selected);
    }

    const inputsProductVariantId = document.querySelectorAll("input[name='id'].product-variant-id");
    inputsProductVariantId.forEach((input) => {
      if (this.currentVariant) {
        input.value = this.currentVariant.id;
      }
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();

    this.skeleton = document.getElementById("product-recommandations-cart-drawer-skeleton");
    this.swiperProductGrid = document.getElementById("swiperProductGrid");
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    this.skeleton?.classList.remove("hidden");
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        //On initialise le swiper
        const sliderElement = this.querySelector(".swiperProductGrid");
        if (sliderElement) {
          const swiperProductGrid = new Swiper(sliderElement, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            breakpoints: {
              1024: {
                slidesPerView: 3,
              },
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-drawer-items") || this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);

      this.removeEcologicalDelivery();
    });
  }

  removeEcologicalDelivery() {
    const ecologicalDelivery = document.getElementById("ecological-delivery");
    if (ecologicalDelivery && this.dataset.ecologicalDelivery !== "") ecologicalDelivery.removeEcologicalDelivery();
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".main-cart-items",
      },
      {
        id: "free-shipping",
        section: "free-shipping",
        selector: ".free-shipping",
      },
      {
        id: "main-cart-items-page",
        section: "main-cart-items-page",
        selector: ".main-cart-items-page",
      },
      {
        id: "cart-count-header",
        section: "cart-count-header",
        selector: "#cart-count-header",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const errorsDiv = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");

        if (parsedState.errors) {
          errorsDiv.textContent = parsedState.errors;
          errorsDiv.style.display = "block";
        } else {
          this.getSectionsToRender().forEach((section) => {
            const elementsWithId = document.querySelectorAll(`#${section.id}`);
            elementsWithId.forEach((element) => {
              const elementToReplace = element.querySelector(section.selector) || element;

              // Pour cart-count-header, on remplace l'élément entier pour que les classes soient correctement mises à jour
              if (section.id === "cart-count-header") {
                const newElement = this.getSectionDOM(parsedState.sections[section.section], section.selector);
                if (newElement && elementToReplace.parentNode) {
                  elementToReplace.parentNode.replaceChild(newElement, elementToReplace);
                }
              } else {
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }
            });
          });

          this.disableLoading(line);
        }
      })
      .catch((e) => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) => overlay.classList.add("hidden"));
        const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector(".cart-item__error-text").innerHTML = window.cartStrings.quantityError.replace("[quantity]", quantityElement.value);
    }

    const textareas = document.querySelectorAll("textarea#CartDrawer-Note");

    textareas.forEach((textarea) => {
      textarea.addEventListener("input", (event) => {
        // Récupérer le texte tapé par l'utilisateur
        const text = event.target.value;

        // Modifier le contenu de tous les éléments textarea avec l'ID "CartDrawer-Note"
        textareas.forEach((textarea) => {
          textarea.innerText = text;
        });
      });
    });

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionDOM(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cursor-not-allowed");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line}`);

    const cartDrawerItemElementsLine = document.getElementById(`CartItem-${line}`);
    cartDrawerItemElementsLine.style.opacity = ".5";

    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cursor-not-allowed");

    const cartDrawerItemElementsLine = document.getElementById(`CartItem-${line}`);
    if (cartDrawerItemElementsLine) {
      cartDrawerItemElementsLine.style.opacity = "1";
    }
  }
}

customElements.define("cart-items", CartItems);

class CompletezVotreTenue extends HTMLElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector("span");
    this.cart = document.getElementById("cart-drawer");

    this.openCart = new CustomEvent("open-cart");
    this.closeCart = new CustomEvent("close-cart");
  }

  connectedCallback() {
    this.initializeCompletezVotreTenue();
  }

  initializeCompletezVotreTenue() {
    if (this.submitButton) {
      this.submitButton.addEventListener("click", this.onSubmit.bind(this));
    }
  }

  onSubmit(event) {
    event.preventDefault();
    console.log("submit completez votre tenue");
    this.addProductsToCart();
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  async addProductsToCart() {
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    const config = fetchConfig("javascript");
    config.method = "POST";
    config.headers["Content-Type"] = "application/json";

    // Récupérer le select
    const product_1 = this.querySelector("#id-product-1");

    let selectedOption_1;
    if (product_1.tagName === "INPUT") {
      // Récupérer la valeur de l'input
      selectedOption_1 = product_1;
    } else {
      // Récupérer l'option sélectionnée
      selectedOption_1 = product_1.options[product_1.selectedIndex];
    }
    // Accéder au data-delais-de-livraison de l'option
    const delais_de_livraison_1 = selectedOption_1.dataset.delaisDeLivraison;

    // Récupérer le select
    const product_2 = this.querySelector("#id-product-2");

    let selectedOption_2;
    // Vérifier si product_2 vient d'un input ou d'un select
    if (product_2.tagName === "INPUT") {
      // Récupérer la valeur de l'input
      selectedOption_2 = product_2;
    } else {
      // Récupérer l'option sélectionnée
      selectedOption_2 = product_2.options[product_2.selectedIndex];
    }

    // Accéder au data-delais-de-livraison de l'option
    const delais_de_livraison_2 = selectedOption_2.dataset.delaisDeLivraison;

    var items = [
      {
        id: product_1.value,
        quantity: 1,
      },
      {
        id: product_2.value,
        quantity: 1,
      },
    ];

    if (delais_de_livraison_1) {
      items[0].properties = {
        delais_de_livraison: delais_de_livraison_1,
      };
    }

    if (delais_de_livraison_2) {
      items[1].properties = {
        delais_de_livraison: delais_de_livraison_2,
      };
    }

    config.body = JSON.stringify({
      items: items,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    await fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        this.cart.renderContents(response);
        window.dispatchEvent(this.openCart);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        this.submitButton.setAttribute("aria-disabled", false);
      });
  }
}

customElements.define("completez-votre-tenue", CompletezVotreTenue);

class ProductRecommandationsCartDrawer extends HTMLElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector("span");
    this.cart = document.getElementById("cart-drawer");

    this.openCart = new CustomEvent("open-cart");
    this.closeCart = new CustomEvent("close-cart");
  }

  connectedCallback() {
    this.initializeCompletezVotreTenue();
  }

  initializeCompletezVotreTenue() {
    if (this.submitButton) {
      this.submitButton.addEventListener("click", this.onSubmit.bind(this));
    }
  }

  onSubmit(event) {
    event.preventDefault();
    this.addProductsToCart();
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  async addProductsToCart() {
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.classList.add("loading");

    const config = fetchConfig("javascript");
    config.method = "POST";
    config.headers["Content-Type"] = "application/json";

    // Récupérer le select
    const product_1 = this.querySelector("#id-product-1");
    // Récupérer l'option sélectionnée
    const selectedOption = product_1.options[product_1.selectedIndex];
    // Accéder au data-delais-de-livraison de l'option
    const delais_de_livraison = selectedOption.dataset.delaisDeLivraison;

    var items = [
      {
        id: product_1.value,
        quantity: 1,
      },
    ];

    if (delais_de_livraison) {
      items[0].properties = {
        delais_de_livraison: delais_de_livraison,
      };
    }

    config.body = JSON.stringify({
      items: items,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    await fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        this.cart.renderContents(response);
        window.dispatchEvent(this.openCart);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.classList.remove("loading");
        this.submitButton.setAttribute("aria-disabled", false);
      });
  }
}

customElements.define("product-recommandations-cart-drawer", ProductRecommandationsCartDrawer);

class ProductDescription extends HTMLElement {
  constructor() {
    super();

    this.readMore = this.querySelector("#read-more");
    this.readLess = this.querySelector("#read-less");
  }

  connectedCallback() {
    const readMoreLinks = this.querySelectorAll(".read-more");

    readMoreLinks.forEach((link) => {
      link.addEventListener("click", this.toggleDescription.bind(this));
    });
  }

  toggleDescription(event) {
    event.preventDefault();
    const fullDescription = this.querySelector(".full-description");
    const shortDescription = this.querySelector(".short-description");
    const readMoreLink = event.target;

    if (!fullDescription.classList.contains("active")) {
      fullDescription.classList.add("active");
      shortDescription.classList.add("hidden");
      this.readMore.classList.add("hidden");
      this.readLess.classList.remove("hidden");
    } else {
      fullDescription.classList.remove("active");
      shortDescription.classList.remove("hidden");
      this.readMore.classList.remove("hidden");
      this.readLess.classList.add("hidden");
    }
  }
}

customElements.define("product-description", ProductDescription);

class DrawerReviews extends HTMLElement {
  constructor() {
    super();

    this.btns = document.querySelectorAll(".drawerReviews");
    this.reviewsDrawerRating = document.getElementById("reviews-drawer-rating");
    this.reviewsDrawerTotalReviews = document.getElementById("reviews-drawer-total-reviews");
    this.reviewsDrawerReviews = document.getElementById("reviews-drawer-reviews");
    this.closeReviews = document.getElementById("closeReviews");
    this.productId = null;
    this.page = 1;
    this.pageCount = null;
    this.pageNext = null;

    this.loadMoreReviewsDiv = document.querySelector(".reviews-item__load-more");
    this.loadMoreReviewsBtn = this.loadMoreReviewsDiv.querySelector("button");

    this.loadMoreReviewsBtn.addEventListener("click", this.loadMoreReviews.bind(this));

    this.feraApiKey = "pk_433664eb1f1d36ef5d32ae65773f64a6a56240459c012dfdff03b1ae49a92606";

    //https://api.fera.ai/v3/public/products/14789676204355/reviews?public_key=pk_433664eb1f1d36ef5d32ae65773f64a6a56240459c012dfdff03b1ae49a92606
  }

  connectedCallback() {
    this.btns.forEach((btn) => {
      btn.addEventListener("click", this.openDrawer.bind(this));
    });

    this.closeReviews.addEventListener("click", this.closeDrawer.bind(this));

    //if click outside
    this.addEventListener("click", (event) => {
      if (event.target.classList.contains("overlay")) {
        this.closeDrawer();
      }
    });
  }

  getProductId(event) {
    this.productId = event.currentTarget.dataset.idProduct;
    return this.productId;
  }

  async getReviews(productId, page = 1) {
    const options = { method: "GET", headers: { accept: "application/json" } };

    // pagination values
    let page_size = 20;

    // header values
    let totalReviews = 0;
    let averageRating = 0;

    let reviews = [];

    try {
      const response = await fetch(`https://api.fera.ai/v3/public/products/${productId}/reviews?public_key=${this.feraApiKey}&page=${page}&page_size=${page_size}`, options);
      const res = await response.json();

      console.log(res);

      // header values
      totalReviews = res.meta.total_count;
      this.reviewsDrawerTotalReviews.textContent = totalReviews;
      averageRating = res.data[0].product.rating.average;
      this.reviewsDrawerRating.textContent = averageRating;

      // pagination values
      this.page = res.meta.page;
      this.pageCount = res.meta.page_count;

      if (this.page < this.pageCount) {
        this.pageNext = this.page + 1;
        this.loadMoreReviewsDiv.style.display = "flex";
      } else {
        this.loadMoreReviewsDiv.style.display = "none";
      }

      // reviews values
      reviews = res.data;
    } catch (err) {
      console.error(err);
    }

    return reviews;
  }

  showReviews(reviews) {
    reviews.forEach((review) => {
      if (review.heading === null) return;

      const reviewCustomerFirstName = review.customer.display_name.split(" ")[0];
      const reviewCustomerCountry = review.customer.display_location ? review.customer.display_location.split(" ")[0].replace(",", "") : "";

      this.reviewsDrawerReviews.innerHTML += `
      <div class="reviews-item__rating flex flex-col pt-[10px] pb-[20px]">
        <span class="reviews-item__rating-text font-heading text-[24px] leading-[24px] tracking-[-0.02em] uppercase pt-[10px]">${review.heading}</span>
        ${review.body !== null ? `<span class=" text-[14px] leading-[19.6px] tracking-[-0.01em] text-gris-5 pt-[10px]">${review.body}</span>` : ""}
        <div class="flex justify-between items-center gap-4 pt-[10px]">
          <span class="text-[12px] leading-[11.76px] tracking-[-0.06em] font-signal">
            ${reviewCustomerFirstName !== null ? `${reviewCustomerFirstName}, ` : ""}${reviewCustomerCountry !== null ? `${reviewCustomerCountry}.` : ""}
          </span>
          <div class="flex items-center pt-[10px] gap-2">
            <span class="text-[12px] leading-[11.76px] tracking-[-0.06em] font-signal">${review.rating}/5</span>
            <span class="reviews-item__rating-stars flex gap-0.5">
            ${Array.from({ length: 5 }, (_, i) => {
              if (i < Math.floor(review.rating)) {
                return `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 0L5.15206 2.41433L7.80423 2.76393L5.86407 4.60567L6.35114 7.23607L4 5.96L1.64886 7.23607L2.13593 4.60567L0.195774 2.76393L2.84794 2.41433L4 0Z" fill="black"/>
            </svg>`; // Étoile pleine
              } else if (i < review.rating) {
                return `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.1516 2.41433L7.80376 2.76393L5.86361 4.60567L6.35068 7.23607L3.99954 5.96L1.6484 7.23607L2.13547 4.60567L0.195312 2.76393L2.84748 2.41433L3.99954 0L5.1516 2.41433ZM5.59539 3.48148L4.7815 4.25408L4.98583 5.35751L4 4.82246V2.32299L4.48282 3.33482L5.59539 3.48148Z" fill="black"/>
            </svg>`; // Étoile à moitié pleine
              } else {
                return `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 1.16101L4.7008 2.62966L4.81767 2.87457L5.08671 2.91004L6.70004 3.1227L5.51983 4.24304L5.32302 4.42987L5.37243 4.69671L5.66872 6.29679L4.23851 5.52055L4 5.3911L3.76149 5.52055L2.33128 6.29679L2.62757 4.69671L2.67698 4.42987L2.48017 4.24304L1.29996 3.1227L2.91329 2.91004L3.18233 2.87457L3.2992 2.62966L4 1.16101Z" stroke="black"/>
            </svg>`; // Étoile vide
              }
            }).join("")}
            </span>
          </div>
        </div>
      </div>
    `;
    });
  }

  async openDrawer(event) {
    this.getProductId(event);

    // Récupération des avis
    const reviews = await this.getReviews(this.productId); // Assurez-vous que getReviews retourne les avis

    this.showReviews(reviews);

    // Ouverture du drawer uniquement si des avis ont été récupérés
    window.dispatchEvent(new CustomEvent("open-drawer-reviews", { detail: this.productId }));
  }

  async loadMoreReviews(event) {
    event.preventDefault();
    this.loadMoreReviewsBtn.classList.add("loading");
    const reviews = await this.getReviews(this.productId, this.pageNext);
    this.showReviews(reviews);
    this.loadMoreReviewsBtn.classList.remove("loading");
  }

  closeDrawer() {
    window.dispatchEvent(new CustomEvent("close-drawer-reviews"));

    setTimeout(() => {
      this.reviewsDrawerReviews.innerHTML = "";
    }, 500);
  }
}

customElements.define("reviews-drawer", DrawerReviews);

class FullscreenGallery extends HTMLElement {
  constructor() {
    super();
    this.body = document.querySelector("body");
    this.images = document.querySelectorAll("[data-fullscreen-gallery-image]");
    this.closeBtn = document.getElementById("fullscreen-gallery-close");
  }

  connectedCallback() {
    this.images.forEach((image) => {
      image.addEventListener("click", this.openFullscreen.bind(this));
    });

    this.closeBtn.addEventListener("click", this.closeFullscreen.bind(this));
  }

  openFullscreen(event) {
    this.body.classList.add("overflow-y-hidden");
    this.classList.add("fixed");
    this.classList.remove("hidden");
    this.autoScrollToImage(event.target.dataset.fullscreenGalleryImage);
  }

  closeFullscreen() {
    this.classList.add("hidden");
    this.classList.remove("fixed");
    this.body.classList.remove("overflow-y-hidden");
  }

  autoScrollToImage(image) {
    const imageElement = document.getElementById(image);
    imageElement.scrollIntoView({ block: "start", inline: "nearest" });
  }
}
customElements.define("fullscreen-gallery", FullscreenGallery);

class EcologicalDelivery extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector("#ecological_delivery");
    this.cart = document.getElementById("cart-drawer");
    this.checkbox.addEventListener("change", this.toggleEcologicalDelivery.bind(this));
  }

  async connectedCallback() {
    await this.initializeEcologicalDelivery();
  }

  async initializeEcologicalDelivery() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        this.getToggleValue().then((value) => {
          this.checkbox.checked = value;
        });
        observer.unobserve(this);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  async getToggleValue() {
    //Get attributes
    const response = await fetch("/cart.js");
    const data = await response.json();
    return data.attributes.livraison_ecologique;
  }

  toggleEcologicalDelivery() {
    //add attributes to cart
    console.log("toggleEcologicalDelivery");

    const config = fetchConfig("javascript");
    config.method = "POST";
    config.headers["Content-Type"] = "application/json";

    const attributes = {
      livraison_ecologique: this.checkbox.checked,
    };

    config.body = JSON.stringify({
      attributes: attributes,
    });

    fetch(`${routes.cart_update_url}`, config)
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
      });
  }

  removeEcologicalDelivery() {
    //Attend 1 seconde
    setTimeout(function () {
      const config = fetchConfig("javascript");
      config.method = "POST";
      config.headers["Content-Type"] = "application/json";

      const attributes = {
        livraison_ecologique: false,
      };

      config.body = JSON.stringify({
        attributes: attributes,
      });

      fetch(`${routes.cart_update_url}`, config)
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        });
    }, 1000);
  }
}
customElements.define("ecological-delivery", EcologicalDelivery);

class searchPopup extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.seeAllResultsButton = this.querySelector("#predictive-search-see-all-results");

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    //Predictive search
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.abortController = new AbortController();
    this.searchTerm = "";

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener("reset", this.onFormReset.bind(this));
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    //this.seeAllResultsButton.addEventListener("click", this.seeAllResults.bind(this));

    this.initializeSearch(this.getQuery());

    /* this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this)); */
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  seeAllResults() {
    console.log("seeAllResults");
    this.input.form.submit();
  }

  onChange() {
    this.toggleResetButton();

    const newSearchTerm = this.getQuery();

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.getSearchNoResult();
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  getSearchNoResult() {
    //Récupérer la section search-popup #predictive-search-results
    fetch(`/?section_id=search-popup`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#predictive-search-results").innerHTML;
        /*   // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
 */
        this.predictiveSearchResults.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        //this.close();
        throw error;
      });
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[options][fields]=title,product_type,variants.title,body,tag&resources[options][unavailable_products]=hide&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          //this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#predictive-search-results").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        //this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      //searchForTextElement.innerText = newButtonText;
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }

    this.getSearchNoResult();
  }

  getQuery() {
    return this.input.value.trim();
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  initializeSearch(searchTerm) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.getSearchResults(searchTerm);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }
}
customElements.define("search-popup", searchPopup);
